import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import {useApi} from "../provider/ApiProvider";
import {DownloadOutlined} from "@ant-design/icons";
import {Button, Popconfirm} from "antd";
import TableComponent from "../components/TableComponent";
import moment from "moment";
import {XYPlot, XAxis, YAxis, HorizontalGridLines, LineSeries,HeatmapSeries,ContourSeries,Borders} from 'react-vis';
export default function Map() {


    const [data, setData] = useState({totalCount: 0, items: []});
    useEffect(() => {

    },[])



    return (
        <LayoutComponent title={"Kullanım Isı Haritası"} links={
            [
                {
                    title: 'Isı Haritası',
                    url: '/'
                },

            ]}
        >
            <XYPlot

                xDomain={[0, 200]}
                yDomain={[0, 200]}
                width={1000}
                height={600}>
                <ContourSeries
                    animation
                    className="contour-series-example"
                    style={{
                        stroke: '#125C77',
                        strokeLinejoin: 'round'
                    }}
                    colorRange={[
                        '#79C7E3',
                        '#FF9833'
                    ]}
                    data={[
                        {x: 85, y: 190},
                        {x: 80, y: 193},
                        {x: 100, y: 0},
                        {x: 102, y: 10},
                        {x: 103, y: 20},
                        {x: 100, y: 30},
                        {x: 102, y: 30},
                        {x: 103, y: 40},
                        {x: 128, y: 42},
                        {x: 130, y: 42},
                        {x: 142, y: 42},
                        {x: 142, y: 38},
                        {x: 108, y: 40},
                        {x: 112, y: 40},
                        {x: 115, y: 40},
                        {x: 120, y: 42},
                        {x: 128, y: 42},
                        {x: 130, y: 12},
                        {x: 142, y: 7},
                        {x: 142, y: 5},
                        {x: 90, y: 40},
                        {x: 80, y: 40},
                        {x: 70, y: 42},
                        {x: 60, y: 62},
                        {x: 130, y: 42},
                        {x: 142, y: 42},
                        {x: 142, y: 38},
                        {x: 100, y: 0},
                        {x: 102, y: 10},
                        {x: 103, y: 20},
                        {x: 100, y: 30},
                        {x: 102, y: 30},
                        {x: 103, y: 40},
                        {x: 108, y: 40},
                        {x: 112, y: 40},
                        {x: 115, y: 40},
                        {x: 120, y: 42},
                        {x: 128, y: 42},
                        {x: 130, y: 42},
                        {x: 142, y: 42},
                        {x: 142, y: 38},
                        {x: 100, y: 0},
                        {x: 102, y: 10},
                        {x: 103, y: 20},
                        {x: 100, y: 30},
                        {x: 102, y: 30},
                        {x: 103, y: 40},
                        {x: 108, y: 40},
                        {x: 112, y: 40},
                        {x: 115, y: 40},
                        {x: 120, y: 42},
                        {x: 128, y: 42},
                        {x: 130, y: 12},
                        {x: 142, y: 7},
                        {x: 142, y: 5},
                        {x: 142, y: 7},
                        {x: 142, y: 5},
                        {x: 142, y: 7},
                        {x: 142, y: 5},
                        {x: 142, y: 7},
                        {x: 142, y: 5},
                        {x: 143, y: 7},
                        {x: 142, y: 5},
                        {x: 144, y: 7},
                        {x: 142, y: 5},
                        {x: 142, y: 7},
                        {x: 142, y: 5},
                        {x: 142, y: 7},
                        {x: 142, y: 5},
                        {x: 90, y: 40},
                        {x: 80, y: 40},
                        {x: 70, y: 42},
                        {x: 60, y: 62},
                        {x: 130, y: 42},
                        {x: 142, y: 42},
                        {x: 142, y: 38}
                    ]}/>

                <Borders style={{all: {fill: '#fff'}}} />
            </XYPlot>
        </LayoutComponent>
    )
}
